(function() {
  'use strict';
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  function init() {
    const container = document.querySelector('[data-section-type="collections-hover"]');
    
    if (!container) {
      return;
    }
    
    const buttons = container.querySelectorAll('[data-hover-target]');
    const images = container.querySelectorAll('[data-collection-image]');
    
    if (buttons.length === 0 || images.length === 0) {
      return;
    }
    
    function switchImage(targetId) {
      const targetImage = container.querySelector('#' + targetId);
      
      if (!targetImage) {
        return;
      }
      
      images.forEach(img => {
        img.classList.remove('is-visible');
      });
      
      buttons.forEach(btn => {
        btn.classList.remove('is-selected');
      });
      
      targetImage.classList.add('is-visible');
      
      const clickedButton = container.querySelector('[data-hover-target="' + targetId + '"]');
      if (clickedButton) {
        clickedButton.classList.add('is-selected');
      }
    }
    
    buttons.forEach((button) => {
      const targetId = button.getAttribute('data-hover-target');
      
      button.addEventListener('mouseenter', function() {
        switchImage(targetId);
      });
      
      button.addEventListener('click', function(e) {
        e.preventDefault();
        switchImage(targetId);
      });
      
      button.addEventListener('touchstart', function() {
        switchImage(targetId);
      }, { passive: true });
    });
  }
  
})();